import React, { useState } from "react";
import { Sidebar } from "../components/sections/navigation/SideBar";
import { Header } from "../components/sections/navigation/Header";
import HorizontalTab, { TabItem } from "../components/ui/HorizontalTab";
import { kafintech_products } from "../constantes/kafintech-product";
import { useProduct } from "../hooks/core/useProduct";

// Types
interface LayoutProps {
  children: React.ReactNode;
}

export const AdminLayout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { selectedProduct, changeProduct } = useProduct();

  const tabs: TabItem[] = [
    { label: 'Tous les produits', value: 'all' },
    ...kafintech_products.map((p) => ({
      label: p.label,
      value: p.value,
    })),
  ];

  const handleChange = (value: string) => {
    changeProduct(value);
  };

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      <Sidebar isCollapsed={sidebarCollapsed} setIsCollapsed={setSidebarCollapsed} />

      {/* ✅ Le défilement (overflow-y-auto) se fait ici maintenant */}
      <div className="flex-1 flex flex-col overflow-y-auto bg-gray-50">

        {/* Header normal : il va monter et disparaître au scroll */}
        <Header onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)} />

      

        {/* ✅ Contenu principal sans scroll séparé */}
        <main className="flex-1 p-4">
          {children}
        </main>
      </div>
    </div>
  );
};